import { GameEvent, OperatorEvent } from "../interfaces/theos.interface";
import { IModuleConfig, IRealityCheckInput } from "../feim/types";
import { registerEventHandler, triggerEventInGame } from "../feim/registerEventHandler";
import { error } from "../utils/log";
import { httpPostRequest } from "../feim/sendHttpPostRequest";
import { sendGameEvent } from "../feim/sendGameEvent";

let handlerExists = false;

/**
 * @internal
 * Internal handler for a reality check using /rcchoice/, so that the game doesn't need to use
 * this undocumented request.
 */
export const handleRcChoice = (config: IModuleConfig): void =>
{
    if (handlerExists) {
        return;
    }

    registerEventHandler<IRealityCheckInput>(OperatorEvent._SEND_RCCHOICE)((data: IRealityCheckInput) =>
    {
        if (config.clientConfig === undefined || config.loginResponse?.sid === undefined) {
            triggerEventInGame(OperatorEvent.P2P_RC_CHOICE, data);

            if (data.action === "continue") {
                sendGameEvent(GameEvent.REALITY_CHECK_RESOLVED);
            }
            return;
        }

        httpPostRequest(`${config.clientConfig.gameServerApi}/rcchoice`, {
            sid: config.loginResponse.sid,
            choice: data.action,
        }).then(() =>
        {
            if (data.action === "continue") {
                // status received. Can be an error, but unfreeze the game anyway - the player can try again
                sendGameEvent(GameEvent.REALITY_CHECK_RESOLVED);
            }
        }).catch((_reason) =>
        {
            error("Failed to send rcchoice");
        });
    });

    handlerExists = true;
};